import styled from "styled-components";

export const Container = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ theme, tightLayout }) =>
    tightLayout ? theme.editor.tightLaneHeight : theme.editor.laneHeight};

  svg {
    width: 100%;
    height: ${({ theme, tightLayout }) =>
      tightLayout ? theme.editor.tightLaneHeight : theme.editor.laneHeight};
    position: absolute;
  }

  svg > polygon {
    transition: filter 0.3s ease-in-out;
  }

  &&.waveform-loading {
    position: absolute;
    top: ${({ theme, tightLayout }) => {
      const laneHeight = parseInt(
        tightLayout
          ? theme.editor.tightLaneHeightNoPx
          : theme.editor.laneHeightNoPx
      );
      return `${laneHeight / 2 - (0.25 * laneHeight) / 2}px`;
    }};
    right: 0;
    left: 0;
    overflow: hidden;
    height: 25%;
    border-radius: ${({ theme }) => theme.borderRadiusContainers};
    opacity: 0.5;

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: translateX(-100%);
      background-image: linear-gradient(
        90deg,
        rgba(100, 100, 100, 0) 0,
        rgba(100, 100, 100, 0.2) 20%,
        rgba(100, 100, 100, 0.5) 60%,
        rgba(100, 100, 100, 0)
      );
      animation: shimmer 2s infinite;
      content: "";
    }

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
`;
